module.exports = __webpack_public_path__ + "static/media/apple-black.8d774a9c.svg";